/* app/controls/control.gallery-grid */

import $ from 'jquery';
import 'Lib/fslightbox/fslightbox';

let $galleryGrids;
const toggleClass = 'show-all';

var GalleryGrid = {
	init: function ($elms) {
		$galleryGrids = $elms;

		GalleryGrid._initEvents();

		GalleryGrid._initLightbox();
	},

	_initEvents: function () {
		$galleryGrids.on('click', '.js-gallery-grid__toggle', GalleryGrid._toggleList);
	},

	_toggleList: function (event) {
		event.preventDefault();

		const $btn = $(this);
		const $thisList = $btn.closest('.js-gallery-grid');

		if ($thisList) {
			$thisList.toggleClass(toggleClass);

			if ($thisList.hasClass(toggleClass)) {
				$btn.text('Show less');
			} else {
				$btn.text('Show more');
			}
		}
	},

	_initLightbox: function () {
		// fslightbox binds to [data-fslightbox] anchors; refresh to pick up those rendered in the grids
		if (typeof window.refreshFsLightbox === 'function') {
			window.refreshFsLightbox();
		}
	}
};

export { GalleryGrid };
